export default class Source {
    // static address = 'http://192.168.0.105:8000';
    // static address = 'http://127.0.0.1:8000';
    // static address = 'https://mydb.hashmatict.com';
    // static address = 'https://test2.hashmatict.com';
    // static address = 'https://anssrt2.hashmatict.com';
    static address = 'https://alnsr2.hashmatict.com';
    // static address = 'https://coins.hashmatict.com';//tailor
    // static address = 'https://demotailor2.hashmatict.com';//tailor
    static getAddress() {
        return this.address;
    }
}